import React from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Image from '@tcp/core/src/components/common/atoms/Image';
import { getIconPath } from '@tcp/core/src/utils';

function AddNewAddress(props) {
  const { addNewLabel, handleAddNew, isMakeDefaultUxUpdateEnabled } = props;
  return (
    <BodyCopy
      component="div"
      role="button"
      tabIndex="0"
      onKeyPress={(e) => e.key === 'Enter' && handleAddNew()}
      onClick={handleAddNew}
      className={`address-carousel-card ${
        isMakeDefaultUxUpdateEnabled ? 'add-newAddress-card' : ''
      }`}
    >
      <div className="add-new-card-content">
        <Image
          className="add-new-img"
          width="30px"
          height="30px"
          src={getIconPath('plus-line')}
          alt="add-new-card"
        />
        <BodyCopy
          fontSize="fs12"
          fontFamily="secondary"
          className="elem-mt-MED add-new-card-label"
          fontWeight="semibold"
        >
          {addNewLabel}
        </BodyCopy>
      </div>
    </BodyCopy>
  );
}

AddNewAddress.propTypes = {
  addNewLabel: PropTypes.string.isRequired,
  handleAddNew: PropTypes.func.isRequired,
  isMakeDefaultUxUpdateEnabled: PropTypes.func.isRequired,
};

export default AddNewAddress;
